// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member-payroll-allowance.page.title': 'Team Member Payroll Allowances',
    'team-member-payroll-allowance.page.search_results': 'Search Results',
    'team-member-payroll-allowance.page.create.title': 'Create New Team Member Payroll Allowance',
    'team-member-payroll-allowance.page.search.title': 'Find Team Member Payroll Allowances',
    'team-member-payroll-allowance.page.edit.title': 'Edit Team Member Payroll Allowance',
    'team-member-payroll-allowance.page.view.title': 'View Team Member Payroll Allowance',
    'team-member-payroll-allowance.page.all': 'All',

    'team-member-payroll-allowance.button.cancel': 'Cancel',
    'team-member-payroll-allowance.button.select': 'Select',
    'team-member-payroll-allowance.button.find': 'Find Team Member Payroll Allowances',
    'team-member-payroll-allowance.button.search': 'Apply',
    'team-member-payroll-allowance.button.create': 'Save Team Member Payroll Allowance',
    'team-member-payroll-allowance.button.new': 'New Team Member Payroll Allowance',
    'team-member-payroll-allowance.button.save': 'Save Changes',
    'team-member-payroll-allowance.button.delete': 'Permanently Delete',
    'team-member-payroll-allowance.button.edit': 'Edit',
    'team-member-payroll-allowance.button.restore': 'Restore',
    'team-member-payroll-allowance.button.reset': 'Reset',

    'team-member-payroll-allowance.placeholder.search': 'Search team member payroll allowances',

    'team-member-payroll-allowance.link.create_first_team_member_payroll_allowance': 'Click here to create your first team member payroll allowance',
    'team-member-payroll-allowance.link.team_member_payroll_allowances': ' Return to Team Member Payroll Allowances',
    'team-member-payroll-allowance.link.retry': 'Click here to retry',

    'team-member-payroll-allowance.checkbox.all': 'Check All',
    'team-member-payroll-allowance.checkbox.actions_label': 'with selected',

    'team-member-payroll-allowance.label.team_member_name': 'Team Member',

    'team-member-payroll-allowance.label.payroll_tax_benefit': 'Payroll Tax Benefit',

    'team-member-payroll-allowance.label.payroll_batch_name': 'Payroll Batch',

    'team-member-payroll-allowance.label.from__used_on': 'From used on',
    'team-member-payroll-allowance.label.to__used_on': 'To used on',
    'team-member-payroll-allowance.label.used_on': 'Used On',

    'team-member-payroll-allowance.label.currency_name': 'Currency',

    'team-member-payroll-allowance.label.from__currency_amount_in_cents': 'From Amount',
    'team-member-payroll-allowance.label.to__currency_amount_in_cents': 'To Amount',
    'team-member-payroll-allowance.label.currency_amount_in_cents': 'Amount',

    'team-member-payroll-allowance.label.from__base_amount_in_cents': 'From base amount in cents',
    'team-member-payroll-allowance.label.to__base_amount_in_cents': 'To base amount in cents',
    'team-member-payroll-allowance.label.base_amount_in_cents': 'Base Amount In Cents',

    'team-member-payroll-allowance.label.from__system_amount_in_cents': 'From system amount in cents',
    'team-member-payroll-allowance.label.to__system_amount_in_cents': 'To system amount in cents',
    'team-member-payroll-allowance.label.system_amount_in_cents': 'System Amount In Cents',

    'team-member-payroll-allowance.label.application_code': 'Application Code',

    'team-member-payroll-allowance.label.application_sub_code': 'Application Sub Code',

    'team-member-payroll-allowance.label.from__created_at': 'From created at',
    'team-member-payroll-allowance.label.to__created_at': 'To created at',
    'team-member-payroll-allowance.label.created_at': 'Created At',

    'team-member-payroll-allowance.label.from__updated_at': 'From updated at',
    'team-member-payroll-allowance.label.to__updated_at': 'To updated at',
    'team-member-payroll-allowance.label.updated_at': 'Updated At',

    'team-member-payroll-allowance.label.from__deleted_at': 'From deleted at',
    'team-member-payroll-allowance.label.to__deleted_at': 'To deleted at',
    'team-member-payroll-allowance.label.deleted_at': 'Deleted At',

    'team-member-payroll-allowance.label.status': 'Status',

    'team-member-payroll-allowance.sort.field_label': 'Field',
    'team-member-payroll-allowance.sort.direction_label': 'Direction',
    'team-member-payroll-allowance.sort.direction_ascending': 'Ascending',
    'team-member-payroll-allowance.sort.direction_descending': 'Descending',

    'team-member-payroll-allowance.modal.title.team_member_payroll_allowance_delete_permanently': 'Delete Team Member Payroll Allowance',
    'team-member-payroll-allowance.modal.title.team_member_payroll_allowance_restore': 'Restore Team Member Payroll Allowance',

    'team-member-payroll-allowance.modal.message.team_member_payroll_allowance_delete_permanently':
        'Are you sure that you want to permanently delete this team member payroll allowance? This action cannot be undone. | Are you sure that you want to permanently delete these team member payroll allowances? This action cannot be undone.',
    'team-member-payroll-allowance.modal.message.team_member_payroll_allowance_restore':
        'Are you sure that you want to restore this team member payroll allowance? | Are you sure that you want to restore these team member payroll allowances?',

    'team-member-payroll-allowance.success.message.team_member_payroll_allowance_created': 'Your team member payroll allowance has been created',
    'team-member-payroll-allowance.success.message.team_member_payroll_allowance_updated': 'Your team member payroll allowance has been updated',
    'team-member-payroll-allowance.success.message.team_member_payroll_allowance_restored': 'Your team member payroll allowance has been restored | All selected team member payroll allowances were restored',
    'team-member-payroll-allowance.success.message.team_member_payroll_allowance_deleted': 'Your team member payroll allowance has been permanently deleted | All selected team member payroll allowances were permanently deleted',

    'team-member-payroll-allowance.error.message.team_member_payroll_allowance_deleted': 'This team member payroll allowance was already permanently deleted | These team member payroll allowances were already permanently deleted',
    'team-member-payroll-allowance.error.message.team_member_payroll_allowance_restored': 'This team member payroll allowance was already restored | These team member payroll allowances were already restored',
    'team-member-payroll-allowance.error.message.error_loading_page': 'Sorry, there was an error loading team member payroll allowance.| Sorry, there was an error loading team member payroll allowances.',
};
